export const DATETIME_API_REGEX =
  /\d{4}-[01]\d-[0-3]\dT[0-2]\d-[0-5]\d-[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z)/;
export const DATETIME_FIXER_REGEX =
  /(T[0-2]\d)(-)([0-5]\d)(-)([0-5]\d)\.\d+([+-][0-2]\d:[0-5]\d|Z)/;
